// Queries
import settings from "./SettingsQuery.gql";

// Mutations
import updateSettings from "./UpdateSettingsMutation.gql";

export const Query = {
    settings,
};

export const Mutation = {
    updateSettings,
};
